import React from "react";
import Tilt from "react-parallax-tilt";
import "./ThreeDCard.css";

const ThreeDCard = ({ title, description, imageSrc }) => {
  return (
    <Tilt
      className="Tilt"
      tiltMaxAngleX={10}
      tiltMaxAngleY={10}
      scale={1.05}
      perspective={1000} // 👈 Adds depth for 3D effect
      glareEnable={true}
      glareMaxOpacity={0.2}
      transitionSpeed={500}
    >
      <div className="Tilt-inner p-6 bg-[#f5f3eb] dark:bg-[#1c1c1c] border border-gray-300 dark:border-gray-700 rounded-lg shadow-lg flex flex-col relative">
        
        {/* Title & Description (Doesn't move) */}
        <div className="text-container mb-4 w-full relative z-20">
          <h3 className="text-lg font-bold text-[#4b534e] dark:text-white">{title}</h3>
          <p className="text-sm text-[#7fc7e6] dark:text-gray-400 mt-2">{description}</p>
        </div>

        {/* Image - Pops out more in 3D */}
        <div className="image-container w-full flex-grow overflow-hidden rounded-lg relative z-10">
          <Tilt
            className="image-tilt"
            tiltMaxAngleX={20}
            tiltMaxAngleY={20}
            scale={1.1} // 👈 Image "pops out" more
            transitionSpeed={500}
          >
            <img 
              src={imageSrc} 
              alt={title} 
              className="object-cover w-full h-full rounded-lg image-pop"
            />
          </Tilt>
        </div>
      </div>
    </Tilt>
  );
};

export default ThreeDCard;

